import type SubjectAddress from '@Domain/Subjects/SubjectAddress';

export type SubjectLeftAction = {
	type: 'SUBJECT_LEFT';
	payload: { typeKey: string; subjectId: number };
};

export default (subject: SubjectAddress): SubjectLeftAction => ({
	type: 'SUBJECT_LEFT',
	payload: { typeKey: subject.typeKey, subjectId: subject.subjectId },
});
